import React from 'react';

import './NotAdminMessagePage.scss';

const NotAdminMessagePage = () => {
  // const { isLoggedin } = useSelector((state) => state.signInReducer);

  return (
    <section className="tmx-notAdminMessagePage">
      <div>You do not have access to the admin dashboard please click here to request access</div>
    </section>
  );
};

export default NotAdminMessagePage;
